import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import PortfolioViewer from './pages/PortfolioViewer';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/portfolio-viewer" element={<PortfolioViewer />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

